import { actions } from 'pages/documents_v2/config/views';
import { useParams } from 'react-router-dom';

export function useIsEditMode() {
    const { view } = useParams();

    return view === actions.EDIT;
}
